import { AppContextAction } from "./../types/AppTypes";
import { AppStateType } from "./AppContextTypes";

const AppContextReducer = (state: AppStateType, action: AppContextAction): AppStateType => {
    return { ...state, ...action.payload };
};

export { AppContextReducer };
